import getTrackLineRequests, {GetTrackLineRequestsOptions} from './getTrackLineRequests';

export default async function fetchTrackMultiline(
    options: GetTrackLineRequestsOptions
): Promise<TrackMultiLine> {
    const lines = await Promise.all(getTrackLineRequests(options).map(request => request.geometry));
    return {
        type: 'Feature',
        properties: options.track.properties,
        geometry: {
            type: 'MultiLineString',
            coordinates: lines.map(line => line.coordinates)
        }
    };
}
